import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {CookiePolicyModalComponent} from "@app/shared/components/cookie-policy-modal/cookie-policy-modal.component";
import {CookiePolicyModalService} from "@app/shared/components/cookie-policy-modal/cookie-policy-modal.service";
import {ModalModule} from "@pb-labs/modal";
import {ButtonModule} from "@pb-labs/button";

@NgModule({
  declarations: [CookiePolicyModalComponent],
  imports: [CommonModule, ModalModule, ButtonModule],
  exports: [CookiePolicyModalComponent],
  providers: [CookiePolicyModalService],
})
export class CookiePolicyModalModule {}
